import React, { useState, useEffect, useRef } from "react";

import "../App.css";
import ModalComponent from "./ModalComponent";
import AddressModal from "./AddressModal";
// import AllRateOptions from "./AllRateOptions";
import bootstrap from "bootstrap";
//import { isMobile } from "react-device-detect";
//import { useLocation } from "react-router-dom";
import DOMPurify from "dompurify";
import { Frame } from "./Header";
import { FrameBottom } from "./footer";
import { generateDeviceId } from "./FingerprintDevice";
import ReactGA from "react-ga";
 import  SmartAppBanner from "./SmartBanner";
// import Helmet from 'react-helmet';
// import AppBanner from 'react-smart-app-banner'
 
//function LoLanding(props) {
const LoLanding = (props) => {
  const isProduction = process.env.REACT_APP_NODE_ENV === "production";
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = navigator.userAgent.toLowerCase().includes("android");
  
  // Conditionally set the path based on the environment
  const imagePath = isProduction
    ? window.location.hostname.includes("localhost")
      ? "../"
      : "https://www.directmortgage.com/R/"
    : "../";

  const srcUrl = isProduction
    ? "https://www.directmortgage.com/"
    : "http://www.solutioncenter.biz/";
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLoButtonOption, setIsOpenLoButtonOption] = useState(false);
  const [loanOfficerId, setLoanOfficerId] = useState(0);
  const [loanOff, setLoanOff] = useState("0");
  const [loDetails, setLoDetails] = useState([]);
  const [socialNetwork, setSocialNetwork] = useState([]);
  const [loanQuoteJson, setLoanQuoteJson] = useState([]);
  const [lineId, setLineId] = useState([]);
  const [loanQuoteId, setLoanQuoteId] = useState([]);
  const [contentURL, setContentURL] = useState("");
  const [optionClicked, setOptionClicked] = useState(0);
  const [intSelected, setIntSelected] = useState("0%");
  const [deviceId, setDeviceId] = useState("");
  const [loEmail, setLoEmail] = useState("");
  const [lOFooterImage, setLOFooterImage] = useState("");
  const [phoneInput, setPhoneInput] = useState("");
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [lockAttributes, setLockAttributes] = useState("");
  const [isAllRateOptionsOpen, setIsAllRateOptionsOpen] = useState(false);
  const [rateOptionAttributes, setRateOptionAttributes] = useState("");
  const [loanNum, setLoanNum] = useState(0);
  const [publicIP, setPublicIP] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMediumSize, setIsMediumSize] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1400
  );

  const [isLargeDeskTop, setIsLargeDeskTop] = useState(
    window.innerWidth > 1399
  );
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [appInstalled, setAppInstalled] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const [data, setData] = useState(null);

  useEffect(() => {

    // let params = {
    //   Id: 1, 
    // };
 
    // handleAPI({
    //   name: "GetPublicIPAddress", 
    //   params: params,
    // })
    //   .then(async (response) => { 
    //    setPublicIP(response);
       
    //   })
    //   .catch((err) => console.log("Error from GetPublicIPAddress ====> ", err));
 
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        const ipAddress = data.ip;
        setPublicIP(ipAddress);
        console.log('Your public IP address is:', ipAddress);
      })
      .catch(error => {
        console.error('Error fetching IP address:', error);
      });

 
  }, []);
  
  const appInfo = {
    imageUrl:
      `${imagePath}AppLogo.png`,
    name: 'GoDirect',
    publisher: 'Direct Mortgage Corp',
    infoText: '',
    linkButtonText: 'Install',
    linkUrl:
      'https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone'
  }

  const SessionFrame = React.memo(() => {
    try {
      return (
        <>
          {/* <iframe
            id="IISSessionFrame"
            src="/IISSessionId.asp"
            style={{ display: "none" }}
          /> */}
          <iframe
            id="IISSessionWrapper"
            src="/Login/presentation/webforms/IISSessionWrapper.aspx"
            style={{ display: "none" }}
          />
        </>
      );
    } catch (error) {
      return <></>;
    }

    return <></>;
  });

  function handleGetIISid() {
    let iframe = document.getElementById("IISSessionWrapper"),
      IISSessionId = "";
    if (iframe) {
      let iframeDoc = iframe.contentDocument || iframe.contentWindow.document,
        IISSessionEle = iframeDoc.getElementById("hdnIISSessionId");

      if (IISSessionEle) IISSessionId = IISSessionEle.value;
    }
    return IISSessionId || "";
  }

  const dropdownRef = useRef(null);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
    setIsMediumSize(window.innerWidth >= 768 && window.innerWidth < 1400);
    setIsLargeDeskTop(window.innerWidth > 1399);
  };

  const validatePhone = (phoneNumber) => {
    const filter =
      /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

    if (filter.test(phoneNumber)) {
      return true;
    } else {
      return false;
    }
  };

  const formatPhone = () => {
    let strPhone = phoneInput.replace(/\D/g, ""); // remove any characters that are not numbers

    const phoneLen = strPhone.length;

    if (phoneLen < 10) {
      return phoneInput;
    }

    if (strPhone !== "") {
      strPhone = strPhone.replace(/-/g, "");
      strPhone = strPhone.replace(/\(/g, "");
      strPhone = strPhone.replace(/\)/g, "");
      strPhone = strPhone.replace(/ /g, "");

      const p = /^([\d]{3})([\d]{3})([\d]{4,})$/.exec(strPhone);

      if (p) {
        const formattedPhone = `(${p[1]}) ${p[2]}-${p[3]}`;
        setPhoneInput(formattedPhone);
      }
    }
  };

  const fnSendAppLink = async () => {
    if (phoneInput != "") {
      var isValid = validatePhone(phoneInput);
      if (isValid == false) {
        return;
      }
    }

    let params = {
      TeamURL: "",
      CellPhone: phoneInput,
      Email: "",
    };

    handleAPI({
      name: "SendShareAppLink",
      params: params,
    })
      .then(async (response) => {
        console.log(response);
        setPhoneInput("");
      })
      .catch((err) => console.log("Error from fnSendAppLink ====> ", err));
  };

  const fnGoToApp = async () => {
    window.location.href = "https://directmortgage.com/S/f6QTt";
  };

  const fnGoToHome = async () => {
    window.location.href = "https://www.directmortgage.com";
  };

  const fnGoToLogin = async () => {
    window.location.href = "https://www.directmortgage.com/sitelogin/";
  };

  const fnMenuItems = async (GoTo) => {
    if (GoTo == 1)
      window.location.href = "https://www.directmortgage.com/home-loans/";

    if (GoTo == 2)
      window.location.href =
        "https://www.directmortgage.com/wholesale/wholesaleresources/";

    if (GoTo == 3) window.location.href = "https://www.directmortgage.com";

    if (GoTo == 4)
      window.location.href = "https://www.directmortgage.com/sitelogin/";
  };

  useEffect(() => {
    //  GetDeviceId();
    GetDeviceId();
    ReactGA.initialize("G-B49VM8XFJ8");
    // document.addEventListener("click", handleClickOutside);

    // return () => {
    //   document.removeEventListener("click", handleClickOutside);
    // };
  
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the clicked element is outside the dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Perform your desired actions here
        console.log("Clicked outside dropdown");

        // You may want to close the dropdown or do something else
        setIsOpen(!isOpen);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("click", handleClickOutside);

    // Clean up the event listener on component unmount
    // return () => {
    //   document.removeEventListener("click", handleClickOutside);
    // };
  }, [dropdownRef]);


   

  const toggleDropdown = (lnQuoteId, LineIdn, LoanNum) => {
    if (isNumeric(LineIdn) && isNumeric(lnQuoteId)) {
      setLineId(LineIdn);
      setLoanQuoteId(lnQuoteId);
      setLoanNum(LoanNum);
      setIsOpen(!isOpen);
      setIsOpenLoButtonOption(false);
    }
  };

  const toggleLoButtonDropdown = () => {
    setIsOpenLoButtonOption(!isOpenLoButtonOption);
    setIsOpen(false);
    setLineId([]);
    setLoanQuoteId([]);
  };

  // const handleClickOutside = (event) => {
  //   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //     setIsOpen(false);
  //   }
  // };

  const GetDeviceId = async () => {
    let visitorid = await generateDeviceId();
    setDeviceId(visitorid);
  };

  //   useEffect(() => {
  //     if (isNumeric(loanQuoteId)) setIsOpen(!isOpen);
  //   }, [loanQuoteId]);

  const [isMoreInfoVisible, setIsMoreInfoVisible] = useState(false);

  const toggleMoreInfoVisibility = () => {
    setIsMoreInfoVisible(!isMoreInfoVisible);
  };

  // const handleItemClick = (item) => {
  //   // Handle item click, e.g., navigate to a different page
  //   //console.log(`Clicked on ${item}`);
  //   // Close the dropdown after item click
  //   setIsOpen(false);
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);

  // useEffect(() => {
  //   if (window.glo_CloseLoginPage === true) {
  //     setIsModalOpen(false);
  //   }
  // }, [window.glo_CloseLoginPage]);

  const openModal = () => {
    setIsModalOpen(true);
    setIsOpen(false);
    setIsOpenLoButtonOption(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeAddressModal = () => {
    setIsAddressModalOpen(false);
  };

  const closeAllRateOptions = () => {
    setIsAllRateOptionsOpen(false);
  };
  useEffect(() => {
    window.glo_SessionId = ""; // "{D8FE1FAA-7E7F-46F1-9F90-F820AE1A1079}";
    window.GatherId = 0;
    window.ParentPage = "NewLoPage";
    window.glo_CloseLoginPage = false;
    prePare();
    // Add event listener to update state on window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // loanId > 0 && prePare();
    if (loanOff === "0" || loanOff === "") return;

    fnGetLoWebsiteDetails();
  }, [loanOff]);
  // [loanOfficerId]);

  useEffect(() => {
    if (optionClicked == 4) {
      window.glo_CampaignLoginHdrInline =
        "Welcome to the E-Signature Page. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Welcome to the E-Signature Page. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Welcome to the E-Signature Page. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 5) {
      window.glo_CampaignLoginHdrInline =
        "Upload your loan documents here. It's easy. It's secure. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Upload your loan documents here. It's easy. It's secure. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Upload your loan documents here. It's easy. It's secure. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 7) {
      window.glo_CampaignLoginHdrInline =
        "Absolutely! Let's view all of your interest rate options. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Absolutely! Let's view all of your interest rate options. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Absolutely! Let's view all of your interest rate options. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 8) {
      window.glo_CampaignLoginHdrInline =
        "Sure thing! Let's get you an instant customized rate quote. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Sure thing! Let's get you an instant customized rate quote. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Sure thing! Let's get you an instant customized rate quote. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 9) {
      var strLockRateMsg =
        "Absolutely! Let's lock in this <b style='color:black; font-weight:bold'>" +
        intSelected +
        "</b> interest rate. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdrInline = strLockRateMsg;
      window.glo_CampaignLoginHdr = strLockRateMsg;
      window.glo_CampaignLoginNewUserHdr = strLockRateMsg;
    }

    if (optionClicked == 10) {
      window.glo_CampaignLoginHdrInline =
        "Sure thing! This step will set up your very own Interest Rate Notifications. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Sure thing! This step will set up your very own Interest Rate Notifications. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Sure thing! This step will set up your very own Interest Rate Notifications. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 11) {
      window.glo_CampaignLoginHdrInline =
        "Check Your Loan Status here. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Check Your Loan Status here. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Check Your Loan Status here. Please start by providing your phone number or email address.";
    }

    if (optionClicked == 1 || optionClicked == 6 || optionClicked == 12) {
      window.glo_CampaignLoginHdrInline =
        "Absolutely! Let's complete your loan application. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginHdr =
        "Absolutely! Let's complete your loan application. Please start by providing your phone number or email address.";
      window.glo_CampaignLoginNewUserHdr =
        "Absolutely! Let's complete your loan application. Please start by providing your phone number or email address.";
    }
    // console.log(window.glo_SessionId);
  }, [optionClicked]);

  useEffect(() => {
    // if (loanQuoteJson[0] != null && loanQuoteJson[0] != undefined) {
    //   setLineId(loanQuoteJson[0]["lineid"]);
    //   setLoanQuoteId(loanQuoteJson[0]["LoanQuoteId"]);
    // }
    console.log(deviceId);

    window.GloParentDeviceId = deviceId;
  }, [deviceId]);

  useEffect(() => {
    if (loDetails.length > 0) {
      //    console.log(loDetails[0].DisplayName);
      let DisplayName = loDetails[0].DisplayName;
      let CompanyName = loDetails[0].CompName;
      let LoanOfficerEmail = loDetails[0].LoEmail;
      let LOFooterImage = loDetails[0].LOFooterImage;
      let EmpNum = loDetails[0].EmpNum;

      window.LoanOfficerId = EmpNum;

      setLoanOfficerId(EmpNum);
      setLoEmail(LoanOfficerEmail);
      setLOFooterImage(LOFooterImage);
      let PageTitle = DisplayName + " - " + CompanyName;
      document.title = PageTitle;
      let pageURL = window.location.href;
      fnLogDWVisitorsEventOnLoad(pageURL, PageTitle);


      // var metaTag = document.querySelector('meta[name="apple-itunes-app"]');
      // if (metaTag) {
      //     var currentContent = metaTag.getAttribute('content');
      //     // Replace the value of the data parameter with the provided data
      //     var newContent = currentContent.replace(/(app-argument=.*?)(&|$)/, 'app-argument=com.directcorp.godirectmortgage://?LoEmpNum=' +  EmpNum);
      //     metaTag.setAttribute('content', newContent);

       

      // }

      // let metaTag = document.querySelector('meta[name="apple-itunes-app"]'); 
      // let newContent ="app-id=6458930558, app-argument=com.directcorp.godirectmortgage://?LoEmpNum=" + EmpNum;
      // metaTag.setAttribute('content', newContent);

      // //  const metaTag = document.createElement('meta');
      // //   metaTag.setAttribute('name', 'apple-itunes-app');
      // //   // Add your content attribute if needed
      // //    metaTag.setAttribute('content', 'app-id=6458930558, app-argument=com.directcorp.godirectmortgage://?LoEmpNum=' + EmpNum);
      // //   document.head.appendChild(metaTag);
        

      // var metaTag1 = document.querySelector('meta[name="smartbanner:button-url-apple"]');

      // // Check if the meta tag exists
      // if (metaTag1) {
      //     // Get the current content attribute value
      //     let currentContent1 = metaTag1.getAttribute('content');
          
      //     // Replace the URL with the new URL containing the EmpNum
      //     let newContent1 = 'https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone&LoEmpNum=' + EmpNum;
          
      //     // Set the new content attribute value
      //     metaTag1.setAttribute('content', newContent1);

      //     // setTimeout(() => {
      //     //   var btnsmartBanners = document.getElementsByClassName("smartbanner__button");
     
      //     //   for (var i = 0; i < btnsmartBanners.length; i++) {
      //     //     btnsmartBanners[i].href="#";
      //     //     btnsmartBanners[i].onclick = function(){ 
               
      //     //       if(isIOS)
      //     //       {
      //     //           try{
      //     //               window.location.href="com.directcorp.godirectmortgage://?LoEmpNum=" +  EmpNum;
      //     //           }
      //     //           catch(e)
      //     //           {
      //     //             window.location.href="https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone";
      //     //           }
      //     //       }
      //     //     };
  
      //     //   }

      //     // }, 500);

          
      // }
    
      if (publicIP)
      {
        let params = {
          IPAddress: publicIP, 
          LoanOfficerId: EmpNum
        };
 
        
        handleAPI({
          name: "StoreLoanOfficerMapping", 
          params: params,
        })
          .then(async (response) => { 
              console.log(response);
           
          })
          .catch((err) => console.log("Error from StoreLoanOfficerMapping ====> ", err));
 
          
      }
      // if (EmpNum==2099)
      // {
      //   window.location.href="com.directcorp.godirectmortgage://?LoEmpNum=" +  EmpNum;
      // }
    }
  }, [loDetails]);

  useEffect(() => {
    console.log(loDetails);
    console.log(socialNetwork);
  }, [loDetails, socialNetwork]);

  //   useEffect(() => {
  //     console.log(loDetails);
  //     console.log(socialNetwork);
  //     console.log(loanQuoteJson);
  //     console.log(deviceId);
  //     // if (loanQuoteJson[0] != null && loanQuoteJson[0] != undefined) {
  //     //   setLineId(loanQuoteJson[0]["lineid"]);
  //     //   setLoanQuoteId(loanQuoteJson[0]["LoanQuoteId"]);
  //     // }
  //   }, [loDetails, socialNetwork, loanQuoteJson, deviceId]);
  const handleGetBrowserName = () => {
    var ua = navigator.userAgent;
    var tem;
    var M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);

    return M[0]; //.join(" ");
  };
  //const CurrentBrowser=handleGetBrowserName();
  let userAgent = navigator.userAgent,
  isFireFox = userAgent.indexOf("Firefox") !== -1,
  isSafari = userAgent.indexOf("Safari") !== -1;
 
  const fnLogDWVisitorsEventOnLoad = async (Url, title) => {
    let params = {
      PageTitle: title,
      PageURL: Url,
      device: isMobile ? "mobile" : "desktop",
      IPAddress: deviceId,
      ParentId: 0,
      detailsJson: JSON.stringify([
        {
          Browser: handleGetBrowserName(),
          LoanId: 0,
        },
      ]),
    };

    await handleAPI({
      name: "LogDWVisitorsEvent",
      params: params,
    })
      .then(async (PageLoadId) => {
        window.GLO_PageLoadId = PageLoadId;
      })
      .catch((err) => console.log("Error from LogDWVisitorsEvent ====> ", err));
  };
  const handleLogDWCallToActionEventParent = async (Buttontext) => {
    try {
      let device = isMobile ? "mobile" : "desktop";

      //  if (Buttontext === "") Buttontext = handleGetButtonText();

      let params = {
        PageTitle: window.document.title,
        PageURL: window.location.href,
        device,
        IPAddress: window.GloParentDeviceId || "",
        ParentId: window.GLO_PageLoadId || "",
        Buttontext,
        detailsJson: JSON.stringify([
          {
            Browser: handleGetBrowserName(),
            LoanId: 0,
            LoanOfficerId: loanOfficerId,
            Email: "",
          },
        ]),
      };

      if (Buttontext !== "") {
        handleAPI({
          name: "fnLogDWCallToActionEvent",
          params,
        })
          .then((response) => {
            ReactGA.event(Buttontext, {
              PageTitle: window.document.title,
              PageURL: window.location.href,
              Device: isMobile ? "mobile" : "desktop",
              DeviceId: window.GloParentDeviceId,
              ParentId: window.GLO_PageLoadId,
              Buttontext: Buttontext,
            });
          })
          .catch((e) =>
            console.log("Error form fnLogDWCallToActionEvent ====> ", e)
          );
      }
    } catch (error) {}
  };

  const handleGetButtonText = (loginFrom) => {
    let Buttontext = "",
      documentURI = document.documentURI;
    if (
      documentURI.includes("StartLoanApp=1") ||
      documentURI.includes("To=loanapp")
    )
      Buttontext = "Start a Loan Application";
    else if (documentURI.includes("LockThisRate=1"))
      Buttontext = "Lock This Interest Rate";
    else if (documentURI.includes("RateOptions=1"))
      Buttontext = "View All Fees and Rate Options";
    else if (documentURI.includes("CustomizeOptions=1"))
      Buttontext = "Customize Your Scenario";
    else if (documentURI.includes("To=ratequote")) Buttontext = "Rate Quote";
    else if (documentURI.includes("To=securedoc"))
      Buttontext = "Upload Documents";
    else if (documentURI.includes("To=ratewizard&RateQuoteId=undefined"))
      Buttontext = "Track these Rates";
    else if (loginFrom === "securedoc") Buttontext = "Upload Documents";
    else if (loginFrom === "loanapp") Buttontext = "Apply Online";

    return Buttontext;
  };

  const fnGetLoWebsiteDetails = async () => {
    if (loanOff === "IISSessionWrapper.aspx" || loanOff === "IISSessionId.asp")
      return;

       
    await handleAPI({
      name: "GetLoWebsiteDetails",
      params: {
        LoanOff: loanOff,
      },
    })
      .then(async (response) => {
        response = JSON.parse(response);
 
        let LoDetails = response["WebSite"][0].LoDetails;
        let SocialNet = response["WebSite"][0].SocialNet;
        let LoanQuoteJson = response["WebSite"][0].LoanQuoteJson;
        setLoDetails(JSON.parse(LoDetails));
        setSocialNetwork(JSON.parse(SocialNet));
        setLoanQuoteJson(JSON.parse(LoanQuoteJson));

        // console.log("--------------------------------");
      })
      .catch((err) =>
        console.log("Error from GetLoWebsiteDetails ====> ", err)
      );
  };

  const handleAPI = async ({ name, params, method, requestOptions = null }) => {
    let url = "https://www.directmortgage.com/LoginCredentialsAPI/api/"; //API_URL;
    params = Object.keys(params)
      .map(
        (key) => `${key}=${params[key]?.toString()?.replaceAll("&", "U00026")}`
      )
      .join("&");

    if (
      window.location.host === "localhost:3000" ||
      window.location.host === "localhost:3001"
    ) {
      url = "http://www.solutioncenter.biz/LoginCredentialsAPI/api/";
    }
 
    try {
      return fetch(
        `${url}${name}?${params}`,
        requestOptions
          ? requestOptions
          : {
              method: method || "POST",
              mode: "cors",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
      )
        .then(async function (response) {
          let res = await response.json();

          return res;
        })
        .catch(function (err) {
          console.log(`Error from handleAPI ====>  ${err}`);
        });
    } catch (error) {}
  };

  const getCurrentTimestamp = () => {
    // Get the current timestamp in milliseconds
    const currentDate = new Date();

    // Get individual date and time components
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(currentDate.getDate()).padStart(2, "0");
    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    // Format the timestamp as "YYYY-MM-DD HH:MM:SS"
    //  const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;
    return timestamp;
  };

  const handleRateOptionClick = (option, IntRate) => {
    const currentTimestamp = getCurrentTimestamp();
    const IISSessionId = handleGetIISid();
    let url = "";
    if (option === 1) {
      url =
        srcUrl +
        "GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(1);
      openModal();

      return;
    }

    if (option === 2) {
      url =
        srcUrl +
        "GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(2);
      openModal();
      return;
    }

    if (option === 3) {
      window.parent.location.href =
        "../../../GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;
      return;
    }
    if (option === 4) {
      //window.parent.location.href = "www.esignnow.com";
      //url = "www.esignnow.com";
      // https://www.directcorp.com/GoDirect/index.html?To=esign&dummyparam=1&SessionGuid=siorutrifogz3ry45ytfflta
      url =
        srcUrl +
        "GoDirect/index.html?To=esign&timestamp=" +
        currentTimestamp +
        "&HideHeader=1&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(4);
      openModal();
      return;
    }
    if (option === 5) {
      url =
        srcUrl +
        "GoDirect/index.html?To=securedoc&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId +
        "&Publicpage=1";

      setContentURL(url);
      setOptionClicked(5);
      openModal();
      return;
    }
    if (option === 6) {
      //window.parent.location.href = "www.directmortgage.com";
      //   url =
      //     "https://www.directmortgage.com/GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
      //     currentTimestamp +
      //     "&From=LoanOfficerWebsite&loanofficer=" +
      //     loanOfficerId +
      //     "&dummyparam=1";

      url =
        srcUrl +
        "GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(6);
      openModal();
      handleLogDWCallToActionEventParent("Start a Loan Application");
      return;
    }
    if (option === 7) {
      url =
        srcUrl +
        "GoDirect/index.html?To=ratewizard&RateQuoteId=" +
        loanQuoteId +
        "&HomePage=1&RateOptions=1&lineid=" +
        lineId +
        "&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(7);
      handleLogDWCallToActionEventParent("See all rates for this product");

      const RateOptionAttributes = {
        IntRate: IntRate,
        LoanQuoteId: loanQuoteId,
        LineId: lineId,
        LoEmail: loEmail,
        DataColumn: 2,
        LoanId: loanNum,
      };
      console.log(RateOptionAttributes);
      setIntSelected(IntRate);
      setRateOptionAttributes(RateOptionAttributes);

      openModal();
      return;

      // if (!window.glo_SessionId) openModal();
      // else {
      //   fnAllRateOptionsModal();
      // }

      //return;
    }
    if (option === 8) {
      url =
        srcUrl +
        "GoDirect/index.html?To=ratewizard&RateQuoteId=" +
        loanQuoteId +
        "&CustomizeOptions=1&lineid=" +
        lineId +
        "&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(8);
      handleLogDWCallToActionEventParent("Customize a scenario");
      openModal();

      return;
    }
    if (option === 9) {
      url =
        srcUrl +
        "GoDirect/index.html?To=ratewizard&RateQuoteId=" +
        loanQuoteId +
        "&HomePage=1&LockThisRate=1&lineid=" +
        lineId +
        "&timestamp=" +
        currentTimestamp +
        "&From=LoanOfficerWebsite&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;
      // loginSrc =
      //   "../GoDirect/index.html?To=ratewizard&RateQuoteId=" +
      //   LoanQuoteId +
      //   "&HomePage=1&LockThisRate=1&lineid=" +
      //   lineid +
      //   "&From=" +
      //   From +
      //   "&timestamp=" +
      //   new Date().getTime();
      //btnLockThisIntRate
      const NewLockAttributes = {
        IntRate: IntRate,
        LoanQuoteId: loanQuoteId,
        LineId: lineId,
      };

      setLockAttributes(NewLockAttributes);
      setContentURL(url);
      setOptionClicked(9);
      setIntSelected(IntRate);
      handleLogDWCallToActionEventParent("Lock this interest Rate");

      // fnShowAddressModal();
      // return;
      if (!window.glo_SessionId) openModal();
      else {
        fnShowAddressModal();
      }

      return;
    }
    if (option === 10) {
      url =
        srcUrl +
        "GoDirect/index.html?To=ratewizard&RateQuoteId=" +
        "&Campaign=TrackTheseRates&TrackTheseRates=1&lineid=" +
        "&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(10);
      handleLogDWCallToActionEventParent("Track interest Rates");
      openModal();

      return;
    }
    if (option === 11) {
      //window.parent.location.href =
      //   url =
      //     "../../../GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
      //     currentTimestamp +
      //     "&From=LoanOfficerWebsite&loanofficer=" +
      //     loanOfficerId +
      //     "&dummyparam=1";

      url =
        srcUrl +
        "GoDirect/index.html?dummyparam=1&SessionGuid=" +
        IISSessionId +
        "&Mobile=" +
        isMobile.toString();

      setContentURL(url);
      setOptionClicked(11);
      handleLogDWCallToActionEventParent("Login");
      openModal();
      return;
    }
    if (option === 12) {
      //window.parent.location.href = "www.directmortgage.com";
      //   url =
      //     "https://www.directmortgage.com/GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
      //     currentTimestamp +
      //     "&From=LoanOfficerWebsite&loanofficer=" +
      //     loanOfficerId +
      //     "&dummyparam=1";

      url =
        srcUrl +
        "GoDirect/index.html?To=loanapp&RateQuoteId=&HomePage=1&StartLoanApp=1&From=LoanOfficerWebsite&timestamp=" +
        currentTimestamp +
        "&loanofficer=" +
        loanOfficerId +
        "&Mobile=" +
        isMobile.toString() +
        "&dummyparam=1&SessionGuid=" +
        IISSessionId;

      setContentURL(url);
      setOptionClicked(12);
      openModal();
      handleLogDWCallToActionEventParent("Apply Now");
      return;
    }

    if (option === 13) {
       
        //window.location.href=   srcUrl +"/Login/Presentation/Webforms/DownloadApp.htm"
       // alert(appInstalled);
      if (isIOS){
        window.location.href = "https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone";
        // if (isSafari){
        //   try{
        //   window.location.href = "com.directcorp.godirectmortgage://";
        //   }
        //   catch(e)
        //   {
        //     window.location.href = "https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone";
        //   }
        // }
        // else
        //   window.location.href = "https://apps.apple.com/us/app/go-direct-mortgage/id6458930558?platform=iphone";
                     
      }
      if (isAndroid) {
          // Redirect to the mobile app store URL
          window.location.href = "https://play.google.com/store/apps/details?id=com.directcorp.godirectmortgage";
      }


      return;
    }
  };
  const fnShowAddressModal = () => {
    setIsModalOpen(false);
    setIsOpen(false);
    setIsAddressModalOpen(true);
  };
  const fnAllRateOptionsModal = () => {
    setIsModalOpen(false);
    setIsOpen(false);
    setIsAllRateOptionsOpen(true);
  };

  //const location = useLocation();
  const isNumeric = (value) => {
    // Use the JavaScript isNaN function to check if the value is numeric
    return !isNaN(value) && !isNaN(parseFloat(value));
  };

  const prePare = () => {
    // const location = useLocation();

    let pathname = window.location.href;
    const isLastCharSlash = pathname.charAt(pathname.length - 1) === "/";

    if (isLastCharSlash) pathname = pathname.slice(0, -1);

    // const { pathname } = location;

    // Split the path by "/" to get an array of segments
    const pathSegments = pathname.split("/");

    // // Get the last segment
    const lastSegment = pathSegments[pathSegments.length - 1];

    //  setLoanOfficerId("1");
    let LoOff = lastSegment.split("?")[0];
    if (loanOff === "IISSessionWrapper.aspx" || loanOff === "IISSessionId.asp") return;
    if (LoOff != "0" && LoOff != "") setLoanOff(LoOff);

    // // Split the last segment by "?" to separate the value from the query string
    // const [value] = lastSegment.split("?");
    // alert(getQueryString("value", ""));
  };

  const modalContent = (
    <>
      <div
        style={{
          height: 80,
          background: "#B8F550",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(1)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              Purchase
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              Start a new loan application
            </div>
          </div>

          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
          background: "#AAE349",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(2)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              Refinance
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              Start a new loan application
            </div>
          </div>
          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow1.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
          background: "#9FD343",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(3)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              Download App
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              Download the mobile app
            </div>
          </div>
          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow2.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
          background: "#93C43E",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(4)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              eSign
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              eSign your loan disclosures
            </div>
          </div>
          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow3.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
          background: "#85B238",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(5)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "flex-start",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              Upload
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              Upload your loan documents
            </div>
          </div>
          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow4.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
          background: "#7AA333",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: 8,
          border: "1px rgba(0, 0, 0, 0.50) solid",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 10,
          display: "flex",
          cursor: "pointer",
        }}
        onClick={() => handleRateOptionClick(6)}
      >
        <div
          style={{
            width: 250,
            paddingLeft: 4,
            justifyContent: "center",
            alignItems: "center",
            gap: 50,
            display: "inline-flex",
          }}
        >
          <div
            style={{
              flex: "1 1 0",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: 6,
              display: "inline-flex",
            }}
          >
            <div
              style={{
                color: "black",
                fontSize: 14,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "700",
                wordWrap: "break-word",
              }}
            >
              Login
            </div>
            <div
              style={{
                color: "black",
                fontSize: 12,
                fontFamily:
                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
            >
              Already have an account?
            </div>
          </div>
          <img
            className="pull-right"
            style={{
              width: "18px",
              height: "18px",
              top: "-0.59px",
              position: "relative",
              float: "right",
              display: "inline-flex",
              marginRight: "5px",
            }}
            src={`${imagePath}VectorArrow5.png`}
            alt=""
          />
        </div>
      </div>
      <div
        style={{
          height: 80,
        }}
      ></div>
    </>
  );

  const createMarkup = (htmlString) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  return (
    <>
     {/* {isMobile && !isSafari  ? <SmartAppBanner/> : <></>} */}
  
      
      {!isMobile ? <Frame /> : <></>}
      {loDetails &&
        loDetails.length > 0 &&
        loDetails.map((row, index) => (
          <div
            className={isMobile ? "" : "container"}
            style={{ flex: 1, overflowX: "hidden" }}
          >
            <div className="row" style={{ display: isMobile ? "" : "none" }}>
              <div
                className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                style={{ paddingTop: 10, paddingLeft: 16,}}
              >
                <img
                  className="directmortgagetrans"
                  style={{
                    cursor: "pointer",
                    width: 180,
                    height: 85,
                  }}
                  alt="Directmortgagetrans"
                  src={`${imagePath}NewAppLogo.png`}
                  onClick={() => fnMenuItems(3)}
                />
              </div>

              <div
                className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                style={{
                  width: "100%",
                  paddingTop: 24,
                  paddingBottom: 24,
                  paddingRight: 12,
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  display: "inline-flex",
                  cursor: "pointer",
                }}
                onClick={() => toggleSidebar()}
              >
                <img
                  style={{
                    width: 24,
                    height: 20.91,
                    cursor: "pointer",
                  }}
                  src={`${imagePath}Vector.png`}
                  alt=""
                />
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ paddingTop: isMobile ? 30 : 10 }}
              ></div>
            </div>
            <div className="row blueBandFullSize">
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  height:
                    isMoreInfoVisible && isMobile
                      ? "auto"
                      : isMobile
                      ? row.LOWebsiteButtonOptions == 2
                        ? 600
                        : 530
                      : isMediumSize
                      ? 330
                      : 275, // make it Auto , so whe there is content it will grow 837
                  width: "100%",
                  left: 0,
                  top: 168,
                  background:
                    "linear-gradient(360deg, #1a1a1a 0%, #4D4D4D 100%)",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.15)",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                  marginLeft: 0,
                }}
              >
                <div
                  className="row"
                  style={{
                    marginTop: 30,
                  }}
                  // style={{
                  //   marginTop: isMobile ? 100 : 30,
                  //   position: isMobile ? "absolute" : "relative",
                  //   top: isMobile ? -35 : 0,
                  // }}
                >
                  <div
                    className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    style={{
                      textAlign: isMediumSize ? "left" : "center",
                      //textAlign: "center",
                      paddingLeft: isMediumSize ? "2rem" : "",
                      height: isMobile ? 145 : "auto",
                    }}
                  >
                    <img
                      style={{
                        // width: isMobile ? 140 : 150,
                        // height: isMobile ? 196 : 200,
                        maxWidth: isMobile ? 200 : 200,
                        maxHeight: isMobile ? 200 : 200,

                        //left: "35%",
                        //  top: -80,
                        // position: "absolute",
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
                        borderRadius: 4,
                        zIndex: isMobile ? "auto" : 9999,
                        //position: "sticky",

                        top: isMobile ? -60 : "auto",
                        position: isMobile ? "relative" : "absolute",
                      }}
                      src={row.LoPhotoPath} // "https://www.directcorp.com/LoanOfficer/23596/Jim3-2.jpg" //{row.LoPhotoPath} //
                      alt=""
                    />
                  </div>
                  <div
                    className="col-xs-12 col-sm-12 col-md-5 col-lg-4"
                    style={{
                      paddingLeft: isMobile ? 15 : isMediumSize ? 45 : 75,
                      textAlign: isMobile ? "center" : "left",
                    }}
                  >
                    <span className="clsName">{row.DisplayName}</span>
                    <span
                      className="clsNmls"
                      style={{ display: isMobile ? "inline-block" : "block" }}
                    >
                      NMLS ID: {row.NMLS}{" "}
                    </span>
                    <span
                      className="clsMoreInfo"
                      onClick={toggleMoreInfoVisibility}
                      style={{ display: isMobile ? "" : "none" }}
                    >
                      | Bio
                    </span>
                    {isMoreInfoVisible && (
                      <>
                        <div
                          className="row"
                          style={{
                            marginTop: 1,

                            position: "relative",
                            // paddingBottom: 0,
                            textAlign: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="white"
                            className="bi bi-triangle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767z"
                            />
                          </svg>
                        </div>

                        <div className="rowBio">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{
                              // width: "100%",
                              // height: "100%",
                              color: "black",
                              fontSize: 12,
                              fontFamily: "'Inter', sans-serif",
                              fontWeight: "300",
                              wordWrap: "break-word",
                              justifyContent: "center",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "left",
                                background: "white",
                                width: 500,
                                height: "auto",
                                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                                borderRadius: 6,
                                color: "black",
                                fontSize: 12,
                                fontWeight: "300",
                                wordWrap: "break-word",
                                padding: 10,
                                fontFamily: "'Inter', sans-serif",
                              }}
                            >
                              {createMarkup(row.LoBiography)}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      class="container"
                      style={{
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                        paddingTop: 5,
                        // paddingLeft: 53,
                        display: isMobile ? "inline-block" : "none",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: 13,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "700",
                          display: "inline-block",
                        }}
                      >
                        Licensed in:&nbsp;
                      </span>
                      <span
                        style={{
                          color: "white",
                          fontSize: 12,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "400",
                          wordWrap: "break-word",
                        }}
                      >
                        {row.LicensedIn}
                      </span>
                    </div>
                    {row.LOWebsiteButtonOptions == 2 ? (
                      <>
                        <div
                          className="row"
                          style={{ display: isMobile ? "none" : "" }}
                        >
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{
                              paddingLeft: 30,
                              paddingRight: 30,
                              paddingTop: 10,
                              paddingBottom: 10,

                              background:
                                "linear-gradient(180deg, #459946 0%, #367837 100%)",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                              borderRadius: 8,
                              border: "1px #265427 solid",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 10,

                              cursor: "pointer",
                              marginTop: "2rem",
                              width: "187px",
                              height: "fit-content",
                              display: "inline-flex",
                            }}
                            onClick={() => handleRateOptionClick(12)}
                          >
                            <div
                              style={{
                                color: "#FFFFFF",
                                fontSize: 21,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "600",
                                wordWrap: "break-word",

                                width: "fit-content",
                              }}
                            >
                              Apply Now
                            </div>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{ display: isMobile ? "none" : "" }}
                        >
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{
                              width: "187px",
                              height: "fit-content",
                              paddingLeft: 30,
                              paddingRight: 30,
                              paddingTop: 10,
                              paddingBottom: 10,
                              background: "rgba(0, 0, 0, 0.11)",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                              borderRadius: 8,
                              border: "3px #459946 solid",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 10,
                              display: "inline-flex",
                              marginTop: 9,
                              cursor: "pointer",
                            }}
                            onClick={() => handleRateOptionClick(11)}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                color: "#3C853D",
                                fontSize: 21,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "600",
                                wordWrap: "break-word",
                              }}
                            >
                              Login
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className="row"
                          style={{
                            display: isMobile ? "none" : "",
                            marginLeft: "0px",
                            justifyContent: isMobile ? "center" : "",
                          }}
                        >
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{
                              paddingLeft: 30,
                              paddingRight: 30,
                              paddingTop: 10,
                              paddingBottom: 10,

                              background:
                                "linear-gradient(180deg, #459946 0%, #367837 100%)",
                              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                              borderRadius: 8,
                              border: "1px #265427 solid",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 10,

                              cursor: "pointer",
                              marginTop: "2rem",
                              width: isMobile ? 250 : 214,
                              height: "fit-content",
                              display: "inline-flex",
                            }}
                            onClick={() => toggleLoButtonDropdown()}
                          >
                            <div
                              style={{
                                color: "#FFFFFF",
                                fontSize: 21,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "600",
                                wordWrap: "break-word",

                                width: "fit-content",
                              }}
                            >
                              Get Started
                            </div>
                            <img
                              className="pull-right"
                              style={{
                                width: "24px",
                                height: "24px",
                                top: "-0.59px",
                                position: "relative",
                                float: "right",
                                display: "inline-flex",
                              }}
                              src={`${imagePath}arrow-down-svgrepo-com.png`}
                              alt=""
                            />
                          </div>
                        </div>
                      </>
                    )}
                    {isOpenLoButtonOption && (
                      <div
                        ref={dropdownRef}
                        style={{
                          textAlign: "left",
                          zIndex: 9999,
                          position: "relative",
                          justifyContent: isMobile ? "center" : "",
                          display: isMobile ? "none" : "",
                        }}
                      >
                        <div
                          style={{
                            width: isMobile ? 250 : 214,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 14,
                            paddingBottom: 14,

                            position: "relative",
                            background:
                              "linear-gradient(90deg, #404040 0%, #232323 100%)",
                            border: "1px #5F5F5F solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 69,
                            display: "inline-flex",
                          }}
                          className="clsOptionsGreen"
                          onClick={() => handleRateOptionClick(1)}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: 14,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            New Loan Application
                          </div>
                        </div>

                        <div
                          style={{
                            width: isMobile ? 250 : 214,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 14,
                            paddingBottom: 14,

                            position: "relative",
                            background:
                              "linear-gradient(90deg, #404040 0%, #232323 100%)",
                            border: "1px #5F5F5F solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 69,
                            display: "inline-flex",
                          }}
                          className="clsOptionsGreen"
                          onClick={() => handleRateOptionClick(5)}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: 14,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            Upload Documents
                          </div>
                        </div>

                        <div
                          style={{
                            width: isMobile ? 250 : 214,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 14,
                            paddingBottom: 14,

                            position: "relative",
                            background:
                              "linear-gradient(90deg, #404040 0%, #232323 100%)",
                            border: "1px #5F5F5F solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 69,
                            display: "inline-flex",
                          }}
                          className="clsOptionsGreen"
                          onClick={() => handleRateOptionClick(4)}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: 14,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            eSign Documents
                          </div>
                        </div>

                        <div
                          style={{
                            width: isMobile ? 250 : 214,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 14,
                            paddingBottom: 14,

                            position: "relative",
                            background:
                              "linear-gradient(90deg, #404040 0%, #232323 100%)",
                            border: "1px #5F5F5F solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 69,
                            display: "inline-flex",
                          }}
                          className="clsOptionsGreen"
                          onClick={() => handleRateOptionClick(11)}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: 14,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            Check Loan Status
                          </div>
                        </div>
                      
                      </div>
                    )}
                  </div>
                  <div
                    className="col-xs-12 col-sm-12 col-md-4 col-lg-4"
                    style={{
                      display: isMobile ? "none" : "",
                      textAlign: "right",
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "white",
                        fontSize: 16,
                        fontFamily:
                          "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      {" "}
                      <img
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: 10,
                        }}
                        src={`${imagePath}Email.png`}
                        alt=""
                      />
                      {/* {row.LoEmail} */}
                      <a
                        href={`mailto:${row.LoEmail}`}
                        style={{
                          color: "white",
                          fontSize: 16,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          textDecoration: "none",
                        }}
                      >
                        {row.LoEmail}
                      </a>
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontSize: 16,
                        fontFamily:
                          "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      <img
                        style={{
                          color: "white",
                          marginRight: 10,
                          wordWrap: "break-word",
                        }}
                        src={`${imagePath}Phone.png`}
                        alt=""
                      />
                      {/* {row.DisplayPhone} */}
                      <a
                        href={`tel:${row.DisplayPhone}`}
                        style={{
                          color: "white",
                          fontSize: 16,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          textDecoration: "none",
                        }}
                      >
                        {row.DisplayPhone}
                      </a>
                    </div>
                    <div
                      style={{
                        color: "#A9DB27",
                        wordWrap: "break-word",
                        marginTop: 15,
                      }}
                    >
                      {socialNetwork &&
                        socialNetwork.length > 0 &&
                        socialNetwork.map((rowSoNet, index) => (
                          <a href={rowSoNet.SocialNetURL}>
                            <img
                              style={{
                                
                                height: 24,
                                marginRight: 10,
                              }}
                              src={
                                `${imagePath}` +
                                rowSoNet.SocialNetDesc +
                                "1.png"
                              }
                              alt=""
                            />
                          </a>
                        ))}
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        textAlign: "right",
                        marginTop: 65,
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "700",
                          display: "inline-block",
                        }}
                      >
                        Licensed in:&nbsp;
                      </span>
                      <span
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "400",
                          wordWrap: "break-word",
                        }}
                      >
                        {row.LicensedIn}
                      </span>
                    </div>
                  </div>
                </div>

                {row.LOWebsiteButtonOptions == 2 ? (
                  <>
                    <div
                      className="row"
                      style={{ display: isMobile ? "inline-flex" : "none" }}
                    >
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div
                          style={{
                            paddingLeft: 30,
                            paddingRight: 30,
                            paddingTop: 10,
                            paddingBottom: 10,

                            background:
                              "linear-gradient(180deg, #459946 0%, #367837 100%)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                            borderRadius: 8,
                            border: "1px #265427 solid",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 10,
                            display: "inline-flex",

                            cursor: "pointer",
                            marginTop: "3rem",
                            width: "190px",
                          }}
                          onClick={() => handleRateOptionClick(12)}
                        >
                          <div
                            style={{
                              color: "#FFFFFF",
                              fontSize: 24,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              width: "fit-content",
                            }}
                          >
                            Apply Now
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="row"
                      style={{ display: isMobile ? "inline-flex" : "none" }}
                    >
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <div
                          style={{
                            width: "190px",
                            height: "fit-content",
                            paddingLeft: 30,
                            paddingRight: 30,
                            paddingTop: 10,
                            paddingBottom: 10,
                            background: "rgba(0, 0, 0, 0.11)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                            borderRadius: 8,
                            border: "3px #265427 solid",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 10,
                            display: "inline-flex",
                            marginTop: 9,
                            cursor: "pointer",
                          }}
                          onClick={() => handleRateOptionClick(11)}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              color: "#265427",
                              fontSize: 24,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                            }}
                          >
                            Login
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="row"
                      style={{
                        display: isMobile ? "" : "none",
                        marginLeft: "0px",
                        justifyContent: isMobile ? "center" : "",
                      }}
                    >
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          paddingLeft: 30,
                          paddingRight: 30,
                          paddingTop: 10,
                          paddingBottom: 10,

                          background:
                            "linear-gradient(180deg, #459946 0%, #367837 100%)",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                          borderRadius: 8,
                          border: "1px #265427 solid",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 10,

                          cursor: "pointer",
                          marginTop: "2rem",
                          width: isMobile ? 250 : 210,
                          height: "fit-content",
                          display: "inline-flex",
                        }}
                        onClick={() => toggleLoButtonDropdown()}
                      >
                        <div
                          style={{
                            color: "#FFFFFF",
                            fontSize: 21,
                            fontFamily:
                              "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                            fontWeight: "600",
                            wordWrap: "break-word",

                            width: "fit-content",
                          }}
                        >
                          Get Started
                        </div>
                        <img
                          className="pull-right"
                          style={{
                            width: "24px",
                            height: "24px",
                            top: "-0.59px",
                            position: "relative",
                            float: "right",
                            display: "inline-flex",
                          }}
                          src={`${imagePath}arrow-down-svgrepo-com.png`}
                          alt=""
                        />
                      </div>
                    </div>
                  </>
                )}
                {isOpenLoButtonOption && (
                  <div
                    ref={dropdownRef}
                    style={{
                      textAlign: "left",
                      zIndex: 9999,
                      position: "relative",
                      justifyContent: isMobile ? "center" : "",
                      display: isMobile ? "grid" : "none",
                    }}
                  >
                                     <div
                          style={{
                            width: isMobile ? 250 : 214,
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingTop: 14,
                            paddingBottom: 14,

                            position: "relative",
                            background:
                              "linear-gradient(90deg, #404040 0%, #232323 100%)",
                            border: "1px #5F5F5F solid",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 69,
                            display: "inline-flex",
                          }}
                          className="clsOptionsGreen"
                          onClick={() => handleRateOptionClick(13)}
                        >
                          <div
                            style={{
                              color: "white",
                              fontSize: 14,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              cursor: "pointer",
                            }}
                          >
                            Get Mobile App
                          </div>
                        </div>
                    <div
                      style={{
                        width: isMobile ? 250 : 210,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 14,
                        paddingBottom: 14,

                        position: "relative",
                        background:
                          "linear-gradient(90deg, #404040 0%, #232323 100%)",
                        border: "1px #5F5F5F solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 69,
                        display: "inline-flex",
                      }}
                      className="clsOptions"
                      onClick={() => handleRateOptionClick(1)}
                    >
                      <div
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        New Loan Application
                      </div>
                    </div>

                    <div
                      style={{
                        width: isMobile ? 250 : 210,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 14,
                        paddingBottom: 14,

                        position: "relative",
                        background:
                          "linear-gradient(90deg, #404040 0%, #232323 100%)",
                        border: "1px #5F5F5F solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 69,
                        display: "inline-flex",
                      }}
                      className="clsOptions"
                      onClick={() => handleRateOptionClick(5)}
                    >
                      <div
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        Upload Documents
                      </div>
                    </div>

                    <div
                      style={{
                        width: isMobile ? 250 : 210,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 14,
                        paddingBottom: 14,

                        position: "relative",
                        background:
                          "linear-gradient(90deg, #404040 0%, #232323 100%)",
                        border: "1px #5F5F5F solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 69,
                        display: "inline-flex",
                      }}
                      className="clsOptions"
                      onClick={() => handleRateOptionClick(4)}
                    >
                      <div
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        eSign Documents
                      </div>
                    </div>

                    <div
                      style={{
                        width: isMobile ? 250 : 210,
                        paddingLeft: 20,
                        paddingRight: 20,
                        paddingTop: 14,
                        paddingBottom: 14,

                        position: "relative",
                        background:
                          "linear-gradient(90deg, #404040 0%, #232323 100%)",
                        border: "1px #5F5F5F solid",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 69,
                        display: "inline-flex",
                      }}
                      className="clsOptions"
                      onClick={() => handleRateOptionClick(11)}
                    >
                      <div
                        style={{
                          color: "white",
                          fontSize: 14,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          cursor: "pointer",
                        }}
                      >
                        Check Loan Status
                      </div>
                    </div>
   
                  </div>
                )}
                <div
                  className="row"
                  style={{ display: isMobile ? "" : "none", paddingTop: 15 }}
                >
                  <div
                    className="col-xs-12 col-sm-12 col-md-4 col-lg-4"
                    style={{
                      textAlign: "center",
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "white",
                        fontSize: 16,
                        fontFamily:
                          "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      {" "}
                      <img
                        style={{
                          width: "24px",
                          height: "24px",
                          marginRight: 10,
                        }}
                        src={`${imagePath}Email.png`}
                        alt=""
                      />
                      {/* {row.LoEmail} */}
                      <a
                        href={`mailto:${row.LoEmail}`}
                        style={{
                          color: "white",
                          fontSize: 16,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          textDecoration: "none",
                        }}
                      >
                        {row.LoEmail}
                      </a>
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontSize: 16,
                        fontFamily:
                          "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      <img
                        style={{
                          color: "white",
                          marginRight: 10,
                          wordWrap: "break-word",
                        }}
                        src={`${imagePath}Phone.png`}
                        alt=""
                      />
                      {/* {row.DisplayPhone} */}
                      <a
                        href={`tel:${row.DisplayPhone}`}
                        style={{
                          color: "white",
                          fontSize: 16,
                          fontFamily:
                            "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                          fontWeight: "500",
                          wordWrap: "break-word",
                          textDecoration: "none",
                        }}
                      >
                        {row.DisplayPhone}
                      </a>
                    </div>
                    <div
                      style={{
                        color: "#A9DB27",
                        wordWrap: "break-word",
                        marginTop: 15,
                      }}
                    >
                      {socialNetwork &&
                        socialNetwork.length > 0 &&
                        socialNetwork.map((rowSoNet, index) => (
                          <a href={rowSoNet.SocialNetURL}>
                            <img
                              style={{
                                width: 24,
                                height: 24,
                                marginRight: 10,
                              }}
                              src={
                                `${imagePath}` +
                                rowSoNet.SocialNetDesc +
                                "1.png"
                              }
                              alt=""
                            />
                          </a>
                        ))}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                    style={{ height: 30, display: isMobile ? "" : "none" }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                style={{ height: 30 }}
              ></div>
            </div>
            <div
              className="row"
              style={{
                marginLeft: isMobile
                  ? "0.3rem"
                  // ? "-1rem"
                  : loanQuoteJson.length < 1
                  ? 0
                  : isMediumSize
                  ? 0
                  : loanQuoteJson && loanQuoteJson.length > 1
                  ? "10%"
                  : "10%",
              }}
            >
              {/* <div
                className="col-xs-12 col-sm-12 col-md-1 col-lg-1"
                style={{ display: isMobile ? "none" : "" }}
              ></div> */}
              <div
                className={
                  loanQuoteJson && loanQuoteJson.length > 0
                    ? loanQuoteJson.length === 1
                      ? "col-xs-12 col-sm-12 col-md-6 col-lg-6"
                      : "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    : "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                }
                style={{ display: isMobile ? "none" : "", paddingLeft: 0 }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    style={{ height: 30 }}
                  ></div>
                </div>
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                    style={{
                      width: isMobile
                        ? "100%"
                        : loanQuoteJson && loanQuoteJson.length > 1
                        ? "90%"
                        : "100%",
                      height: "100%",
                      color: "black",
                      fontSize: 16,
                      fontFamily:
                        "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                      fontWeight: "500",
                      wordWrap: "break-word",
                    }}
                  >
                    {createMarkup(row.LoBiography)}
                  </div>
                </div>
              </div>
              {loanQuoteJson &&
                (loanQuoteJson.length === 0 || loanQuoteJson.length > 1) && (
                  <div
                    className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    style={{
                      marginTop: 20,
                      marginBottom: 20,
                      width: "87%",
                      display: isMobile ? "none" : "",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        background:
                          "linear-gradient(270deg, rgba(204, 204, 204, 0.25) 0%, rgba(204, 204, 204, 1) 50%, rgba(141, 141, 141, 0.25) 100%)",
                      }}
                    ></div>
                  </div>
                )}
              {loanQuoteJson &&
                loanQuoteJson.length > 0 &&
                loanQuoteJson.map((loanquote, index) => (
                  <>
                    <div
                      className={
                        loanQuoteJson && loanQuoteJson.length > 1
                          ? (loanQuoteJson.length == 3 && index == 2) ||
                            (loanQuoteJson.length == 5 && index == 3)
                            ? "col-xs-12 col-sm-12 col-md-10 col-lg-10"
                            : "col-xs-12 col-sm-12 col-md-5 col-lg-5"
                          : "col-xs-12 col-sm-12 col-md-6 col-lg-6"
                      }
                      style={{
                        marginLeft: isMobile ? 30 : 0,
                        marginBottom: 30,
                        paddingLeft: 0,
                        display: "flex",
                        marginTop:
                          loanQuoteJson && loanQuoteJson.length > 1 ? 20 : 0,
                        justifyContent: isMobile
                          ? ""
                          : (loanQuoteJson.length == 3 && index == 2) ||
                            (loanQuoteJson.length == 5 && index == 3)
                          ? "center"
                          : "left",
                      }}
                    >
                      <div
                        style={{
                          width: 360,
                          height: 330,

                          // position: "absolute",
                          background:
                            "linear-gradient(180deg, #F6F6F6 0%, #E8E8E8 100%)",
                          boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                          borderRadius: 6,
                        }}
                      >
                        <div className="row">
                          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div
                              style={{
                                //left: 107,
                                //top: 510,
                                position: "relative",
                                color: "#646464",
                                fontSize: 24,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "700",
                                wordWrap: "break-word",
                                textAlign: "center",
                              }}
                            >
                              Today’s Rates for
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{ height: 10 }}
                          ></div>
                        </div>

                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{
                              position: "relative",
                              color: "black",
                              fontSize: 13,
                              fontFamily:
                                "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                              fontWeight: "400",
                              wordWrap: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {loanquote.LoanProduct}
                          </div>
                        </div>

                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{ textAlign: "center" }}
                          >
                            <img
                              style={{
                                cursor: "pointer",
                              }}
                              src={`${imagePath}Line1.png`}
                              alt=""
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{ height: 10 }}
                          ></div>
                        </div>
                        <div className="row" style={{ marginLeft: 1 }}>
                          <div
                            className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                            style={{
                              position: "relative",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "inline-flex",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                color: "#88AB35",
                                fontSize: 20,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "700",
                                wordWrap: "break-word",
                              }}
                            >
                              {loanquote.TargetRate}
                            </div>
                            <div
                              style={{
                                textAlign: "center",
                                color: "#696767",
                                fontSize: 16,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "500",
                                wordWrap: "break-word",
                                marginRight: "2rem",
                              }}
                            >
                              Rate
                            </div>
                          </div>
                          <div
                            className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                            style={{
                              position: "relative",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "flex-start",
                              display: "inline-flex",
                            }}
                          >
                            <div
                              style={{
                                textAlign: "center",
                                color: "#88AB35",
                                fontSize: 20,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "700",
                                wordWrap: "break-word",
                              }}
                            >
                              {loanquote.LoanAmount}
                            </div>
                            <div
                              style={{
                                textAlign: "center",
                                color: "#696767",
                                fontSize: 16,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "500",
                                wordWrap: "break-word",
                              }}
                            >
                              Loan amount
                            </div>
                          </div>
                        </div>
                        <div
                          className="row"
                          style={{
                            paddingTop: 20,
                            paddingBottom: 20,
                            marginLeft: 1,
                          }}
                        >
                          <div
                            className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                            style={{
                              position: "relative",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "inline-flex",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                display: "inline-flex",
                              }}
                            >
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#88AB35",
                                  fontSize: 20,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "700",
                                  wordWrap: "break-word",
                                }}
                              >
                                {loanquote.APR}
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#696767",
                                  fontSize: 16,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  marginRight: "2rem",
                                }}
                              >
                                APR
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-xs-6 col-sm-6 col-md-6 col-lg-6"
                            style={{
                              position: "relative",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "flex-start",
                              display: "inline-flex",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                display: "inline-flex",
                              }}
                            >
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#88AB35",
                                  fontSize: 20,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "700",
                                  wordWrap: "break-word",
                                }}
                              >
                                {loanquote.PitiPayment}
                              </div>
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#696767",
                                  fontSize: 16,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                }}
                              >
                                Payment
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{ height: 15 }}
                          ></div>
                        </div>
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                            style={{ textAlign: "center" }}
                          >
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,
                                position: "relative",
                                background: "#4680E1",
                                border: "1px #51617D solid",
                                justifyContent: "center",
                                alignItems: "flex-start",
                                //  gap: 33,
                                display: "inline-flex",
                                justifyContent: "left",
                                borderRadius: 8,
                              }}
                              onClick={() =>
                                toggleDropdown(
                                  loanquote.LoanQuoteId,
                                  loanquote.lineid,
                                  loanquote.loanid
                                )
                              }
                            >
                              <div
                                style={{
                                  color: "#FAFAFA",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                View More Rate Options
                              </div>
                              <img
                                className="pull-right"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  top: "-0.59px",
                                  position: "relative",
                                  float: "right",
                                  display: "inline-flex",
                                }}
                                src={`${imagePath}arrow-down-svgrepo-com.png`}
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                        {isOpen && loanquote.LoanQuoteId === loanQuoteId && (
                          <div
                            ref={dropdownRef}
                            style={{
                              textAlign: "center",
                              marginRight: 21,
                              zIndex: 9999,
                              position: "relative",
                            }}
                          >
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,

                                position: "relative",
                                background:
                                  "linear-gradient(90deg, #404040 0%, #232323 100%)",
                                border: "1px #5F5F5F solid",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: 69,
                                display: "inline-flex",
                              }}
                              className="clsOptions"
                              onClick={() =>
                                handleRateOptionClick(7, loanquote?.TargetRate)
                              }
                            >
                              <div
                                style={{
                                  color: "white",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                See all rates for this product
                              </div>
                            </div>
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,

                                position: "relative",
                                background:
                                  "linear-gradient(90deg, #404040 0%, #232323 100%)",
                                border: "1px #5F5F5F solid",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: 69,
                                display: "inline-flex",
                              }}
                              className="clsOptions"
                              onClick={() => handleRateOptionClick(8)}
                            >
                              <div
                                style={{
                                  color: "white",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                Customize a scenario
                              </div>
                            </div>
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,

                                position: "relative",
                                background:
                                  "linear-gradient(90deg, #404040 0%, #232323 100%)",
                                border: "1px #5F5F5F solid",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: 69,
                                display: "inline-flex",
                              }}
                              className="clsOptions"
                              onClick={() =>
                                handleRateOptionClick(9, loanquote?.TargetRate)
                              }
                            >
                              <div
                                style={{
                                  color: "white",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                Lock this interest Rate
                              </div>
                            </div>
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,

                                position: "relative",
                                background:
                                  "linear-gradient(90deg, #404040 0%, #232323 100%)",
                                border: "1px #5F5F5F solid",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: 69,
                                display: "inline-flex",
                              }}
                              className="clsOptions"
                              onClick={() => handleRateOptionClick(10)}
                            >
                              <div
                                style={{
                                  color: "white",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                Track interest Rates
                              </div>
                            </div>
                            <div
                              style={{
                                width: isMobile ? 250 : 240,
                                paddingLeft: 20,
                                paddingRight: 20,
                                paddingTop: 14,
                                paddingBottom: 14,

                                position: "relative",
                                background:
                                  "linear-gradient(90deg, #404040 0%, #232323 100%)",
                                border: "1px #5F5F5F solid",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                gap: 69,
                                display: "inline-flex",
                              }}
                              className="clsOptions"
                              onClick={() => handleRateOptionClick(6)}
                            >
                              <div
                                style={{
                                  color: "white",
                                  fontSize: 14,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "500",
                                  wordWrap: "break-word",
                                  cursor: "pointer",
                                }}
                              >
                                Start a Loan Application
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* <div
                      className="col-xs-12 col-sm-12 col-md-1 col-lg-1"
                      style={{ display: isMobile ? "none" : "" }}
                    ></div> */}
                  </>
                ))}
            </div>
            <div className="row" style={{ display: isMobile ? "" : "none" }}>
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ height: 30 }}
              ></div>
            </div>
            {isModalOpen && (
              <ModalComponent
                isOpen={isModalOpen}
                onClose={closeModal}
                contentUrl={contentURL}
              />
            )}
            <div className="row" style={{ margin: "0px" }}>
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{
                  backgroundImage: `url(${imagePath}GreenVectorBG.png)`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  height: isMobile ? 320 : 509,
                  margin: isMobile ? "0px 0px" : "100px 0px",
                }}
              >
                <div className="row">
                  <div
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                    }}
                  >
                    <div className="row">
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontSize: 36,
                            fontFamily:
                              "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                            fontWeight: "700",
                            wordWrap: "break-word",
                            width: 296, // Adjusted width
                            height: "88px",
                            textAlign: "right",
                            marginTop: "4rem",
                            textAlign: "left",
                            marginRight: "1rem",
                            lineHeight: "1em",
                          }}
                        >
                          Download our mobile app
                        </div>
                      </div>
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          marginTop: 10,
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            fontSize: 13,
                            fontFamily:
                              "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                            fontWeight: "400",
                            wordWrap: "break-word",
                            width: 311,
                            height: 30,
                            textAlign: "left",
                          }}
                        >
                          Use the mobile app to upload documents, eSign
                          disclosures, check your loan status, and much more.
                        </div>
                      </div>
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          display: isMobile ? "none" : "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          marginTop: 40,
                          marginLeft: 3,
                        }}
                      >
                        <div
                          style={{
                            width: 367,
                            height: 18,
                            textAlign: "right",
                            color: "white",
                            fontSize: 12,
                            fontFamily:
                              "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                            fontWeight: "400",
                            wordWrap: "break-word",
                          }}
                        >
                          Enter your mobile number below to receive a download
                          link
                        </div>
                      </div>

                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          display: isMobile ? "none" : "flex",
                          flexDirection: "column",
                          alignItems: "flex-end",
                          marginTop: 40,
                        }}
                      >
                        <div
                          style={{
                            borderRadius: 2,
                            justifyContent: "center",
                            alignItems: "flex-start",
                            display: "inline-flex",
                            width: 296,
                            height: 18,
                            marginRight: "1rem",
                            boxShadow: "0px 3px 6px 0px RGBA(0,0,0,0.5)",
                          }}
                        >
                          <div className="input-group">
                            <input
                              style={{
                                color: "#8D8D8D",
                                fontSize: 12,
                                fontFamily:
                                  "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                fontWeight: "400",
                                wordWrap: "break-word",
                                width: 201,
                                height: 35,
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Mobile number"
                              value={phoneInput}
                              onChange={(e) => setPhoneInput(e.target.value)}
                              onBlur={() => formatPhone()}
                            />
                            <div
                              className="input-group-append"
                              style={{
                                background: "#4680E1",
                                borderTopLeftRadius: 4,
                                borderTopRightRadius: 4,
                                border: "1px #2F5DAA solid",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 10,
                                display: "flex",
                              }}
                            >
                              <button
                                className="btn"
                                type="button"
                                style={{
                                  color: "white",
                                  fontSize: 12,
                                  fontFamily:
                                    "'segoe ui', Inter, Tahoma, Geneva, Verdana, sans-serif",
                                  fontWeight: "700",
                                  wordWrap: "break-word",
                                }}
                                onClick={() => fnSendAppLink()}
                              >
                                Get the app
                              </button>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                      <div
                        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-end",
                          marginTop: 50,
                          justifyContent: isMobile ? "center" : "flex-end",
                        }}
                      >
                        <img
                          style={{
                            maxHeight: 50,
                            marginRight: "1rem",
                            display: isIOS ? "" : !isMobile ? "" : "none",
                            cursor: "pointer",
                          }}
                          src={`${imagePath}AppleAppStoreShadow.png`}
                          alt="IOS Phone App"
                          onClick={() => fnGoToApp()}
                        />
                        <img
                          style={{
                            maxHeight: 50,
                            marginRight: "1rem",
                            display: isAndroid ? "" : !isMobile ? "" : "none",
                            cursor: "pointer",
                          }}
                          src={`${imagePath}GooglePlayShadow.png`}
                          alt="Android Phone App"
                          onClick={() => fnGoToApp()}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                    style={{
                      alignItems: "left",
                      display: isMobile ? "none" : "flex",
                    }}
                  >
                    <img
                      style={{
                        width: "195px",
                        height: "422px",
                        marginLeft: "4rem",
                        marginRight: "auto",
                        marginTop: "1rem",
                      }}
                      src={`${imagePath}PhoneApp.png`}
                      alt="Phone App"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div
                className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                style={{ height: isMobile ? 30 : 100 }}
              >
                &nbsp;
              </div>
            </div>
            {isSidebarVisible && (
              <nav>
                <ul className="sidebar">
                  <li>
                    <a
                      href="#"
                      onClick={() => toggleSidebar()}
                      style={{ justifyContent: "right" }}
                    >
                      {/* <img
                        style={{
                          width: 24,
                          height: 20.91,
                          cursor: "pointer",
                          display: isMobile ? "" : "none",
                        }}
                        src={`${imagePath}Vector.png`}
                        alt=""
                      /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 -960 960 960"
                        width="24"
                      >
                        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={() => fnMenuItems(3)}>
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={() => fnMenuItems(1)}>
                      Loans
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={() => fnMenuItems(2)}>
                      Resources
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={() => fnMenuItems(4)}>
                      Login
                    </a>
                  </li>
                </ul>
              </nav>
            )}
            {/* {isAllRateOptionsOpen && (
              <AllRateOptions
                isOpen={isAllRateOptionsOpen}
                onClose={closeAllRateOptions}
                SessionId={window.glo_SessionId}
                GatherId={window.GatherId}
                LoanOfficerId={loanOfficerId}
                {...rateOptionAttributes}
              />
            )}

            {isAddressModalOpen && (
              <AddressModal
                isOpen={isAddressModalOpen}
                onClose={closeAddressModal}
                SessionId={window.glo_SessionId}
                GatherId={window.GatherId}
                LoanOfficerId={loanOfficerId}
                {...rateOptionAttributes}
              />
            )}
            <button
              id="btnLockThisIntRate"
              style={{ display: "none" }}
              onClick={() => fnShowAddressModal()}
            ></button> */}
          </div>
        ))}

      <FrameBottom
        RateOptionClick={handleRateOptionClick}
        LOFooterImage={lOFooterImage}
      />

      {isProduction && <SessionFrame />}
    </>
  );
};

export default LoLanding;
